





















import {
  Vue,
  Component, Prop, Watch,
} from "@/shared/vuepack";
import {
} from "@/shared/types";
import { useDistributionSchedulesStore } from "@/shared/store/distributionSchedules";
import TransferSchedulesTable from "@/shared/components/TransferSchedulesTable.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
@Component({
  components: {
    TransferSchedulesTable
  }
})
export default class DistributionSchedules extends Vue {
  distributionSchedulesStore = useDistributionSchedulesStore();
  portalCustomizationStore = usePortalCustomizationStore();

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  @Prop()
  schedulesPage: number;

  mounted (): void {
    const args = { username: this.username, partnerId: this.partnerId };
    this.distributionSchedulesStore.getDistributionSchedules(args);
  }

  get isLoaded (): boolean {
    return this.distributionSchedulesStore.schedulesLoaded;
  }

  @Watch("schedulesPage")
  loadPage () {
    this.distributionSchedulesStore.setSchedulesPage(this.schedulesPage);
  }

  get supportPhone (): string {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted (): string {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }
}
